module.exports = __webpack_public_path__ + "img/mockup-1.3e132343.webp";